import TagApi from "./TagApi";

export default TagApi;
